import { render } from "./RichTextOverlay.vue?vue&type=template&id=c7c66b9c"
import script from "./RichTextOverlay.vue?vue&type=script&lang=js"
export * from "./RichTextOverlay.vue?vue&type=script&lang=js"

import "./RichTextOverlay.vue?vue&type=style&index=0&id=c7c66b9c&lang=scss"
script.render = render

export default script